import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { slideList } from "@/mocks/content";

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return undefined;
    const timer = window.setInterval(() => {
      setIndex((value) => (value + 1) % slideList.length);
    }, 6000);
    return () => window.clearInterval(timer);
  }, [paused]);

  const go = (next: number) => {
    setIndex((next + slideList.length) % slideList.length);
  };

  return (
    <section
      className="relative w-full overflow-hidden bg-primary-950"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      aria-roledescription="轮播"
      aria-label="焦点内容"
    >
      <div className="relative h-[420px] w-full md:h-[520px]">
        {slideList.map((slide, slideIndex) => (
          <div
            key={slide.id}
            className={`absolute inset-0 transition-opacity duration-700 ${
              slideIndex === index ? "opacity-100" : "pointer-events-none opacity-0"
            }`}
            aria-hidden={slideIndex !== index}
          >
            <img
              src={slide.image}
              alt={slide.title}
              title={`${slide.title} - 18禁焦点推荐`}
              className="h-full w-full object-top object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-primary-950/92 via-primary-950/70 to-primary-950/25"></div>
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/70 via-transparent to-primary-950/20"></div>
          </div>
        ))}

        <div className="absolute inset-0">
          <div className="mx-auto flex h-full max-w-[1280px] flex-col justify-end px-4 pb-12 md:px-6 md:pb-16">
            <div className="max-w-2xl">
              <div className="mb-3 flex items-center gap-3">
                <span className="flex h-5 items-center justify-center rounded-sm bg-accent-500 px-1.5 text-[10px] font-bold text-foreground-950">
                  18+
                </span>
                <span className="text-[11px] tracking-[0.22em] text-accent-200">{slideList[index].kicker}</span>
              </div>
              <h1 className="font-heading text-2xl leading-tight text-background-50 md:text-[40px] md:leading-[1.2]">
                {slideList[index].title}
              </h1>
              <p className="mt-4 max-w-xl text-[13px] leading-relaxed text-background-200 md:text-sm">
                {slideList[index].description}
              </p>
              <div className="mt-7 flex flex-wrap items-center gap-3">
                <Link
                  to={`/detail/${slideList[index].detailId}`}
                  className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-medium text-foreground-950 transition hover:bg-accent-400"
                >
                  阅读全文
                  <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
                </Link>
                <Link
                  to="/resources"
                  className="cursor-pointer whitespace-nowrap rounded-md border border-background-50/35 px-5 py-2.5 text-sm font-medium text-background-50 transition hover:border-background-50/70 hover:bg-background-50/10"
                >
                  浏览资源库
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="absolute bottom-5 right-4 flex items-center gap-3 md:bottom-7 md:right-6">
          <div className="flex items-center gap-1.5">
            {slideList.map((slide, dotIndex) => (
              <button
                key={slide.id}
                type="button"
                onClick={() => go(dotIndex)}
                aria-label={`切换到第 ${dotIndex + 1} 张`}
                className={`h-1.5 cursor-pointer rounded-full transition-all ${
                  dotIndex === index ? "w-7 bg-accent-500" : "w-3 bg-background-50/45 hover:bg-background-50/70"
                }`}
              />
            ))}
          </div>
          <span className="text-[11px] tabular-nums tracking-wider text-background-200">
            0{index + 1} / 0{slideList.length}
          </span>
          <div className="flex items-center gap-1.5">
            <button
              type="button"
              onClick={() => go(index - 1)}
              aria-label="上一张"
              className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full border border-background-50/30 text-background-50 transition hover:border-accent-400 hover:text-accent-300"
            >
              <i className="ri-arrow-left-s-line" aria-hidden="true"></i>
            </button>
            <button
              type="button"
              onClick={() => go(index + 1)}
              aria-label="下一张"
              className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full border border-background-50/30 text-background-50 transition hover:border-accent-400 hover:text-accent-300"
            >
              <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}